export const RESOURCE_URL_PLACEHOLDER = 'https://';

export function makeValidAttachmentUrl(url) {
    const trimmedUrl = url.trim();
    if (!/^https?:\/\//.test(trimmedUrl) && !/^#/.test(trimmedUrl)) {
        const urlWithoutBeginningSlashes = trimmedUrl.replace(/^[/]+/, '');
        return `http://${urlWithoutBeginningSlashes}`;
    }
    return trimmedUrl;
}
